<div kendoTooltip geneaRouteData>
  <router-outlet></router-outlet>
  <navigation-indicator></navigation-indicator>
  <app-toastr></app-toastr>
</div>
